import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, getSortState, translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import PartModal from 'app/modules/part/PartModal';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { PageFilters } from 'app/shared/components/page-filters/PageFilters';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { ISearchTypes } from 'app/shared/interfaces/searchTypesInterface';
import { IPart } from 'app/shared/model/part.model';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { Loading } from 'app/shared/util/loading';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC } from 'app/shared/util/pagination.constants';
import { isAdminByCompanyType } from 'app/shared/util/role-utils';
import '../../modules/part/part.scss';
import { getPartDataSummary } from './part.reducer';

export const Part = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const partInfoList = useAppSelector(state => state.part.entities as IPart[]);
  const updateSuccess = useAppSelector(state => state.part.updateSuccess);
  const totalItems = useAppSelector(state => state.part.totalItems);
  const partList = useAppSelector(state => state.part.entities);
  const loading = useAppSelector(state => state.part.loading);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'company'), props.location.search)
  );
  const [selectedPart, setSelectedPart] = useState<IPart | null>(null);
  const [nameSearch, setNameSearch] = useState<string>('');

  const searchTypes: ISearchTypes[] = [
    {
      label: translate('fleetSenseApp.part.searchLabel'),
      placeholder: translate('fleetSenseApp.part.search'),
      value: nameSearch,
      setValue: setNameSearch,
    },
  ];

  const getAllEntities = useCallback(() => {
    dispatch(
      getPartDataSummary({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        nameSearch,
      })
    );

    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  }, [paginationState, updateSuccess]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const setActivePage = () => {
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
  };

  useEffect(() => {
    getAllEntities();
  }, [getAllEntities]);

  const { match } = props;

  return (
    <Fragment>
      <PageHeader
        headingId="part-heading"
        headingDataCy="PartHeading"
        contentKey="fleetSenseApp.part.home.title"
        match={match}
        buttonTextKey="fleetSenseApp.part.home.createLabel"
      />

      <PageFilters setActivePage={setActivePage} searchTypes={searchTypes} showFilters={['filters']} />

      {partList?.length > 0 && !loading ? (
        <Table responsive>
          <thead>
            <tr>
              <th className="hand" onClick={sort('code')}>
                <Translate contentKey="fleetSenseApp.part.code">Code</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('name')}>
                <Translate contentKey="fleetSenseApp.part.name">Name</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('company')}>
                <Translate contentKey="fleetSenseApp.part.type">Type</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {selectedPart && <PartModal part={selectedPart} toggle={() => setSelectedPart(null)} isOpen={!!selectedPart} />}
            {partList.map((part, i) => (
              <Fragment key={i}>
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td onClick={() => setSelectedPart(part)} style={{ cursor: 'pointer' }}>
                    {part.code}
                  </td>
                  <td onClick={() => setSelectedPart(part)} style={{ cursor: 'pointer' }}>
                    {part.name}
                  </td>
                  <td onClick={() => setSelectedPart(part)} style={{ cursor: 'pointer' }}>
                    {isAdminByCompanyType(part.company.type) ? 'Padrão' : '-'}
                  </td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button onClick={() => setSelectedPart(part)} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                      </Button>
                      {(!isAdminByCompanyType(part.company.type) || isAdmin) && (
                        <>
                          <Button tag={Link} to={`${match.url}/${part.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                            <FontAwesomeIcon icon="pencil-alt" />{' '}
                            <span className="d-none d-md-inline">
                              <Translate contentKey="entity.action.edit">Edit</Translate>
                            </span>
                          </Button>
                          <Button
                            tag={Link}
                            to={`${match.url}/${part.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                            color="danger"
                            size="sm"
                            data-cy="entityDeleteButton"
                          >
                            <FontAwesomeIcon icon="trash" />{' '}
                            <span className="d-none d-md-inline">
                              <Translate contentKey="entity.action.delete">Delete</Translate>
                            </span>
                          </Button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              </Fragment>
            ))}
          </tbody>
        </Table>
      ) : (
        loading && <Loading />
      )}
      {!loading && !partList.length && (
        <div className="alert alert-warning text-center">
          <Translate contentKey="fleetSenseApp.part.home.notFound">No Part found</Translate>
        </div>
      )}
      {totalItems && !loading && !!partInfoList.length ? (
        <div className="count-page">
          <Row>
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row>
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        <Fragment />
      )}
    </Fragment>
  );
};

export default Part;
